import { DateTime } from 'luxon';
import { Guid } from '../../classes/guid';
import { ObjectState } from '../../enums/objectState.enum';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';

export class ClientSpaceConfig implements IConfigObjectBase {
	id: string = Guid();
	name = '';
	description?: string;
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();
	objectState?: ObjectState;

	color = '';
	projectIDs: string[] = [];

	constructor(init?: Partial<ClientSpaceConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
